import React, { useEffect, useState, lazy } from 'react';
import { CTAButton } from './CTAButton';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const resultImages = ['https://cdn.magicpatterns.com/uploads/eUXr1L2ENfAzbQbbbmot7u/ad3.jpg', 'https://cdn.magicpatterns.com/uploads/7i74A1uN2D5Dy3E6WCpqoi/ChatGPT_Image_29_abr_2026,_07_21_51_p.m..png', 'https://cdn.magicpatterns.com/uploads/7h1qPU2exeCiQA1AgFwB9M/5.jpg', 'https://cdn.magicpatterns.com/uploads/qS5YCMNmBBeqUf22EATP66/ad7.jpg', 'https://cdn.magicpatterns.com/uploads/fs4t5fx5ZfJXFUVgXYYmCu/ad2.jpg'];
const results = [{
  label: 'TIENDA 1',
  amount: '$47.000.000',
  image: 'https://cdn.magicpatterns.com/uploads/8iQb4yV17KvLsVexiE4yF4/TIENDA_1.jpg'
}, {
  label: 'TIENDA 2',
  amount: '$21.000.000',
  image: 'https://cdn.magicpatterns.com/uploads/e5774hAGZz8777oghUPigq/TIENDA_2.jpg'
}, {
  label: 'TIENDA 3',
  amount: '$42.140.000',
  image: 'https://cdn.magicpatterns.com/uploads/ttY5TSkg5grcyCbbsyQbQJ/TIENDA_3.png'
}];
export function RealResultsSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [heroSlide, setHeroSlide] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % results.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setHeroSlide(prev => (prev + 1) % resultImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const goPrev = () => setCurrentSlide(prev => (prev - 1 + results.length) % results.length);
  const goNext = () => setCurrentSlide(prev => (prev + 1) % results.length);
  const goHeroPrev = () => setHeroSlide(prev => (prev - 1 + resultImages.length) % resultImages.length);
  const goHeroNext = () => setHeroSlide(prev => (prev + 1) % resultImages.length);
  return <section className="py-8 md:py-12 px-4 bg-[#2E0640] pt-[10px] pb-[10px] mt-[0px] mb-[0px]" data-id="element-337">
      <div className="max-w-6xl mx-auto pt-[0px] pb-[0px]" data-id="element-338">
        <div className="text-center mb-12" data-id="element-339">
          <h2 className="md:text-5xl font-[700] text-[25px] text-[#FC9DFF] pt-[10px] pb-[10px] mt-[0px] mb-[0px]" data-id="element-340">
            Aunque todavía no tengas clientas ni experiencia.
          </h2>

          {/* Static image */}
          <div className="max-w-md mx-auto mb-8" data-id="element-341"></div>
        </div>

        <div className="max-w-3xl mx-auto mt-8 mb-8" data-id="element-342">
          <div className="rounded-2xl p-6 md:p-8 bg-[#1a0124] border border-[#FC9DFF]/30 shadow-xl animate-neon-violet mt-[0px] mb-[0px] pt-[34px] pb-[34px]" data-id="element-343">
            <h3 className="md:text-2xl text-white mb-2 font-[Montserrat,_sans-serif] text-[23px] font-[700]" data-id="element-344">
              📈 Proyección de Ingresos: 5 Clientas Nuevas por Semana
            </h3>
            <p className="md:text-base text-[#D9D9D9] italic mb-6 text-[14px] font-[Montserrat,_sans-serif] leading-relaxed" data-id="element-345">
              (Ingreso puro por primeras colocaciones, sin contabilizar futuros
              mantenimientos)
            </p>

            <div className="overflow-x-auto" data-id="element-346">
              <table className="w-full text-left border-collapse" data-id="element-347">
                <thead data-id="element-348">
                  <tr className="border-b border-[#FC9DFF]/30" data-id="element-349">
                    <th className="py-3 pr-3 text-[#FC9DFF] font-bold text-[13px] md:text-sm uppercase tracking-wide align-bottom" data-id="element-350">
                      Tipo de Espacio
                    </th>
                    <th className="py-3 px-3 text-[#FC9DFF] font-bold text-[13px] md:text-sm uppercase tracking-wide align-bottom" data-id="element-351">
                      Valor 1ra Colocación (ARS)
                    </th>
                    <th className="py-3 pl-3 text-[#FC9DFF] font-bold text-[13px] md:text-sm uppercase tracking-wide align-bottom" data-id="element-352">
                      Ingreso Mensual (4 semanas)
                    </th>
                  </tr>
                </thead>
                <tbody className="text-white text-[14px] md:text-base font-[Montserrat,_sans-serif]" data-id="element-353">
                  <tr className="border-b border-[#FC9DFF]/15" data-id="element-354">
                    <td className="py-5 pr-3 align-top leading-snug" data-id="element-355">
                      🏠 <span className="font-bold" data-id="element-356">Home Studio</span>{' '}
                      <span className="text-[#D9D9D9]" data-id="element-357">
                        (Ideal principiantes)
                      </span>
                    </td>
                    <td className="py-5 px-3 align-top" data-id="element-358">$35.000</td>
                    <td className="py-5 pl-3 align-top font-bold" data-id="element-359">
                      $700.000 ARS
                    </td>
                  </tr>
                  <tr className="border-b border-[#FC9DFF]/15" data-id="element-360">
                    <td className="py-5 pr-3 align-top leading-snug" data-id="element-361">
                      💅 <span className="font-bold" data-id="element-362">Showroom / Estudio</span>{' '}
                      <span className="text-[#D9D9D9]" data-id="element-363">
                        (Profesionales con experiencia)
                      </span>
                    </td>
                    <td className="py-5 px-3 align-top" data-id="element-364">$45.000</td>
                    <td className="py-5 pl-3 align-top font-bold" data-id="element-365">
                      $900.000 ARS
                    </td>
                  </tr>
                  <tr data-id="element-366">
                    <td className="py-5 pr-3 align-top leading-snug" data-id="element-367">
                      ✨ <span className="font-bold" data-id="element-368">Salón Premium</span>{' '}
                      <span className="text-[#D9D9D9]" data-id="element-369">
                        (Estética de alto nivel)
                      </span>
                    </td>
                    <td className="py-5 px-3 align-top" data-id="element-370">$60.000</td>
                    <td className="py-5 pl-3 align-top font-bold" data-id="element-371">
                      $1.200.000 ARS
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>;
}